export default "__VITE_ASSET__136e721c__"